// extracted by mini-css-extract-plugin
module.exports = {"dualImgScreen":"styles_dualImgScreen__PQCXZ","imageWrapper":"styles_imageWrapper__qf6eQ","image":"styles_image__EHagj"};